"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.TableWrapper = exports.TableBodyWrapper = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const TableWrapper = exports.TableWrapper = /*#__PURE__*/(0, _base.default)("table", process.env.NODE_ENV === "production" ? {
  target: "e1hlre5g1"
} : {
  target: "e1hlre5g1",
  label: "TableWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "tkxk5i",
  styles: "border-collapse:collapse"
} : {
  name: "tkxk5i",
  styles: "border-collapse:collapse",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const TableBodyWrapper = exports.TableBodyWrapper = /*#__PURE__*/(0, _base.default)("tbody", process.env.NODE_ENV === "production" ? {
  target: "e1hlre5g0"
} : {
  target: "e1hlre5g0",
  label: "TableBodyWrapper"
})();
const styles = exports.styles = {
  cell_defaults: process.env.NODE_ENV === "production" ? {
    name: "rt24rc",
    styles: "text-align:left;line-height:24px;padding:5px 0;padding-right:16px"
  } : {
    name: "12b51o9-cell_defaults",
    styles: "text-align:left;line-height:24px;padding:5px 0;padding-right:16px;label:cell_defaults;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  row_defaults: /*#__PURE__*/(0, _react.css)(process.env.NODE_ENV === "production" ? "" : ";label:row_defaults;"),
  row_border: theme => /*#__PURE__*/(0, _react.css)("border-top:1px solid ", theme.primary, ";border-bottom:1px solid ", theme.primary, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:row_border;")),
  row_danger: theme => /*#__PURE__*/(0, _react.css)("background-color:", theme.alert, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:row_danger;")),
  row_info: theme => /*#__PURE__*/(0, _react.css)("background-color:", theme.info, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:row_info;")),
  row_muted: theme => /*#__PURE__*/(0, _react.css)("background-color:", theme.disabled, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:row_muted;")),
  row_notice: theme => /*#__PURE__*/(0, _react.css)("background-color:", theme.gray10, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:row_notice;")),
  row_success: theme => /*#__PURE__*/(0, _react.css)("background-color:", theme.success, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:row_success;")),
  row_warning: theme => /*#__PURE__*/(0, _react.css)("background-color:", theme.alertLight, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:row_warning;")),
  cell_right: process.env.NODE_ENV === "production" ? {
    name: "2qga7i",
    styles: "text-align:right"
  } : {
    name: "hd1p5l-cell_right",
    styles: "text-align:right;label:cell_right;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  cell_left: process.env.NODE_ENV === "production" ? {
    name: "1flj9lk",
    styles: "text-align:left"
  } : {
    name: "u5gdxj-cell_left",
    styles: "text-align:left;label:cell_left;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  cell_center: process.env.NODE_ENV === "production" ? {
    name: "1azakc",
    styles: "text-align:center"
  } : {
    name: "1fsb877-cell_center",
    styles: "text-align:center;label:cell_center;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  cell_truncate: process.env.NODE_ENV === "production" ? {
    name: "l9a0se",
    styles: "overflow:hidden;white-space:nowrap;text-overflow:ellipsis;&:hover{max-width:none;overflow:inherit;white-space:inherit;word-wrap:break-word;}"
  } : {
    name: "we2dqx-cell_truncate",
    styles: "overflow:hidden;white-space:nowrap;text-overflow:ellipsis;&:hover{max-width:none;overflow:inherit;white-space:inherit;word-wrap:break-word;};label:cell_truncate;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  cell_wrap: process.env.NODE_ENV === "production" ? {
    name: "19u0omh",
    styles: "white-space:normal;word-wrap:break-word"
  } : {
    name: "rj41nf-cell_wrap",
    styles: "white-space:normal;word-wrap:break-word;label:cell_wrap;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  }
};